<template>
  <div class="profile">
    <div class="profile-page">
      <v-container fluid>
        <v-row style="width: 100%">
          <v-col cols="3" class="sidedbar d-flex flex-column" style="height: fit-content">
            <div class="menu-profile">
              <div class="avatar mt-5">
                <div class="img-profile">
                  <img alt="" :src="profile != null ? profile.user_avatar : require('@/assets/image/avatar_male.png')"/>
                </div>
              </div>
              <div class="credit">
                {{ username }}
              </div>
              <div class="credit d-flex flex-row align-items-center" v-if="profile != null">
                <span style="color: white !important;">{{ oracle.translate('اعتبار:') }}</span>
                <span class="font-weight-bold"
                      style="font-size: 15px; color: white !important;">{{ oracle.format(profile.user_wallet) }}</span>
                <span style="color: white !important;">{{ oracle.translate('تومان') }}</span>
              </div>
              <div class="btn-profile mb-5" v-ripple role="button" @click="openCredit">
                <v-btn class="mb-5" color="#7dc353" rounded dark>
                  {{ oracle.translate('افزایش اعتبار') }}
                </v-btn>
              </div>
              <div class="menu-profile mt-5 mb-5">
                <ul>
                  <li
                      v-for="(item, index) in datalist"
                      :key="index"
                      :class="item.key == mode ? 'success' : ''"
                      v-ripple role="button" @click="handelselectmenu(item.key)"
                  >
                    <v-icon
                        :style="isEN ? 'padding-right: 10px;' : 'padding-left: 10px;'">{{ item.icon }}
                    </v-icon>
                    {{ oracle.translate(item.title) }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="mt-5 mb-5"></div>
            <div class="mt-5 mb-5"></div>
            <div class="mt-5 mb-5"></div>
          </v-col>
          <template>
            <v-col v-if="mode === 'support'"
                   cols="9"
                   class="main-profile"
            >
              <Contactus></Contactus>
            </v-col>
            <v-col v-if="mode === 'favorite'"
                   cols="9"
                   class="main-profile"
            >
              <favorites></favorites>
            </v-col>
            <v-col v-if="mode === 'orders'"
                   cols="9"
                   class="main-profile"
            >
              <div class="table-profile">
                <div class="title-table">
                  <table class="table_css table-striped rtl">
                    <thead>
                    <tr>
                      <th class="col-1 font-weight-bold"><p>{{ oracle.translate('کد سفارش') }}</p></th>
                      <th class="col-3 font-weight-bold"><p>{{ oracle.translate('نوع/جزییات سفارش') }}</p></th>
                      <th class="col-5 font-weight-bold"><p>{{ oracle.translate('سبد خرید') }}</p></th>
                      <th class="col-2 font-weight-bold"><p>{{ oracle.translate('زمان ثبت') }}</p></th>
                      <th class="col-1 font-weight-bold"><p>{{ oracle.translate('وضعیت سفارش') }}</p></th>
                    </tr>
                    </thead>
                    <tbody id="table">
                    <tr v-for="(item, index) in orderList" :key="index">
                      <th class="col-1"
                          style="direction: ltr !important;font-family: sans-serif !important; font-weight: bold; font-size: larger">
                        {{ "#" + item.order_code.toUpperCase() }}
                      </th>
                      <th class="col-3">
                        <div class="d-flex flex-row text-right" style="min-width: 100%">
                          <span class="f8"
                                style="color: gray; padding: 0 !important; width: fit-content">{{ oracle.translate('نام فروشگاه:') }}</span>
                          <span style="width: fit-content; padding: 0 !important;"
                                class="f8 font-weight-bold mlx-auto mrx-2">{{ oracle.shop_name(item.shop) }}</span>
                        </div>
                        <div class="d-flex flex-row text-right" style="min-width: 100%">
                          <span class="f8"
                                style="color: gray; padding: 0 !important; width: fit-content">{{ oracle.translate('نوع سفارش:') }}</span>
                          <span style="width: fit-content; padding: 0 !important;"
                                class="f8 font-weight-bold mlx-auto mrx-2">
                            {{
                              oracle.translate(
                                  (item.order_type == 0
                                      ? "سفارش حضوری"
                                      : "سفارش دلیوری")
                              )
                            }}
                          </span>
                        </div>
                        <div v-if="item.order_delivery != null && item.order_delivery > 0"
                             class="d-flex flex-row text-right" style="min-width: 100%">
                          <span class="f8"
                                style="color: gray; padding: 0 !important; width: fit-content">
                            {{ oracle.translate('هزینه پیک:') }}
                          </span>
                          <span style="width: fit-content; padding: 0 !important; color: #4CAF50"
                                class="f8 font-weight-bold mlx-auto mrx-2">{{
                              oracle.format(item.order_delivery)
                            }} {{ oracle.translate('تومان') }}</span>
                        </div>
                        <div class="d-flex flex-row text-right" style="min-width: 100%">
                          <span class="f8"
                                style="color: gray; padding: 0 !important; width: fit-content">{{ oracle.translate('مبلغ کل سفارش:') }}</span>
                          <span style="width: fit-content; padding: 0 !important; color: #4CAF50"
                                class="f8 font-weight-bold mlx-auto mrx-2">{{
                              oracle.format(item.order_price)
                            }} {{ oracle.translate('تومان') }}</span>
                        </div>
                      </th>
                      <th class="col-5">
                        <div>
                          <p class="multi-line text-right"
                             v-for="(item, index) in item.order_detail"
                             :key="index"
                          >
                            {{ oracle.product_title(item) }} ({{
                              item.product_quantity
                            }} {{ oracle.translate('عدد') }})
                          </p>
                          <p v-if="item.order_options_text != null && item.order_options_text.length > 0"
                             class="f7 multi-line text-right rounded pb-2 prx-2 plx-2 mt-2 pt-2"
                             style="width: 100%; background: #804CAF50">
                            {{ item.order_options_text }}
                          </p>
                        </div>
                      </th>
                      <th class="col-2">
                        {{ oracle.formatDate(item.create_at) }}
                      </th>
                      <th style="text-align: center !important;" class="col-1 font-weight-bold text-center">
                        <span
                            v-if="(item.order_refund != null && item.order_refund > 0) || item.order_state != 6 || item.review != null"
                            style="color: white"
                            :style="'background: ' + (item.order_refund != null && item.order_refund > 0 ? '#ffab04' : item.order_state == 1 ? 'red' : '#2ab0f7')"
                            class="rounded-pill w-setup f8 font-weight-bold prx-2 pb-2 pt-2 plx-2">
                          {{ item.stateText }}
                        </span>
                        <v-btn class="w-setup" height="35px" v-else rounded dark small
                               @click="orderFunction(item)"
                               :color="item.order_state == 6 ? '#7dc353' : item.order_state == 1 ? 'red' : '#2ab0f7'">
                          {{ item.stateText }}
                        </v-btn>
                      </th>
                      <!--                                            <th class="col-1 btn-send-message">-->
                      <!--                                                <v-btn color="#7dc353" v-ripple role="button"-->
                      <!--                                                       @click="OpenModalSent(item)"-->
                      <!--                                                >پیام-->
                      <!--                                                </v-btn>-->
                      <!--                                            </th>-->
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div
                    class="content-profile"
                    v-if="orderList != null && orderList.length == 0"
                >
                  <span>{{ oracle.translate('نتیجه ای یافت نشد') }}</span>
                </div>
              </div>
            </v-col>
            <v-col v-if="mode === 'addresses'" cols="9" class="main-profile">
              <Addresses></Addresses>
            </v-col>
            <v-col v-if="mode === 'payments'"
                   cols="9"
                   class="main-profile"
            >
              <div class="title-table-payments">
                <table class="table_css table-striped rtl">
                  <thead>
                  <tr>
                    <th class="col-2">{{ oracle.translate('نام فروشگاه') }}</th>
                    <th class="col-2">{{ oracle.translate('زمان سفارش') }}</th>
                    <th class="col-8">{{ oracle.translate('فاکتور خرید') }}</th>
                  </tr>
                  </thead>
                  <tbody id="table2">
                  <tr v-for="(item, index) in paymentList" :key="index">
                    <th style="border-bottom: 1px solid black !important;" class="col-8 text-right">
                      {{ item.payment_description }}
                    </th>
                    <th style="border-bottom: 1px solid black !important;" class="col-2">
                      {{ oracle.formatDate(item.create_at) }}
                    </th>
                    <th style="border-bottom: 1px solid black !important;" class="col-2">{{
                        oracle.format(item.payment_amount) + " " + oracle.translate("تومان")
                      }}
                    </th>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="content-payments" v-if="paymentList != null && paymentList.length == 0">
                <span>{{ oracle.translate('نتیجه ای یافت نشد') }}</span>
              </div>
            </v-col>
            <v-col v-if="mode === 'messages'"
                   cols="9"
                   class="main-profile"
            >
              <div class="title-table-messages">
                <table class="table_css table-striped rtl">
                  <thead>
                  <tr>
                    <th class="col-2">{{ oracle.translate('عنوان') }}</th>
                    <th class="col-8">{{ oracle.translate('متن پیام') }}</th>
                    <th class="col-2">{{ oracle.translate('تاریخ') }}</th>
                  </tr>
                  </thead>
                  <tbody id="table3">
                  <tr v-for="(item, index) in messageList" :key="index">
                    <th style="border-bottom: 1px solid black !important;" class="col-4 text-right">
                      {{ item.message_title }}
                    </th>
                    <th style="border-bottom: 1px solid black !important;" class="col-6 text-right">
                      {{ item.message_body }}
                    </th>
                    <th style="border-bottom: 1px solid black !important;" class="col-2">
                      {{ oracle.formatDate(item.create_at) }}
                    </th>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="content-messages" v-if="messageList != null && messageList.length == 0">
                <span>{{ oracle.translate('نتیجه ای یافت نشد') }}</span>
              </div>
            </v-col>
            <v-col v-if="mode === 'userinfo'"
                   cols="9"
                   class="main-profile showprofile"
            >
              <div class="content-user-info">
                <v-row>
                  <v-col cols="3">
                    <div class="field-user-info">
                      <label> <span class="star">* </span>{{ oracle.translate('نام و نام خانوادگی') }}</label>
                      <v-text-field
                          v-model="username"
                          dir="auto"
                          solo
                          hide-details
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="3">
                    <div class="field-user-info">
                      <label>{{ oracle.translate('شماره موبایل') }}</label>
                      <v-text-field
                          v-model="phone"
                          disabled
                          dir="auto"
                          solo
                          hide-details
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="3">
                    <div class="field-user-info">
                      <label>{{ oracle.translate('ایمیل') }}</label>
                      <v-text-field
                          v-model="email"
                          dir="auto"
                          solo
                          hide-details
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="3">
                    <div class="field-user-info">
                      <label>{{ oracle.translate('تاریخ تولد') }}</label>
                      <v-text-field
                          v-model="birth_date"
                          dir="auto"
                          solo
                          hide-details
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div class="btn-user-info mt-5 mb-5">
                <v-btn color="#7dc353" v-ripple role="button" @click="EditeProfile()">
                  {{ oracle.translate('ذخیره تغییرات حساب کاربری') }}
                </v-btn>
              </div>
            </v-col>
          </template>
        </v-row>
      </v-container>
    </div>

    <v-dialog v-model="dialogCreat" max-width="500">
      <v-card class="box-modals profile">
        <div class="title-modal-creat">
          <h3 class="font-weight-bold" style="color: white">{{ oracle.translate('افزایش اعتبار') }}</h3>
          <v-icon v-ripple role="button" @click="dialogCreat = false">close</v-icon>
        </div>
        <div class="content-modal-creat">
          <span>{{ oracle.translate('مبلغ دلخواه خود را جهت افزایش اعتبار را وارد نمایید') }}</span>
          <div class="field-modal-creat">
            <v-text-field
                dir="auto"
                autofocus
                solo
                persistent-hint
                v-model="pricewall"
                :hint="oracle.translate('مبلغ ورودی به تومان')"
            ></v-text-field>
          </div>
          <v-btn style="width: 60%" color="#7dc353" class="btn-modal-creat" v-ripple role="button"
                 @click="CreateWall()">
            {{ oracle.translate('شارژ کیف پول درون برنامه ای') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="ratingModal" max-width="700">
      <v-card class="profile prx-3 plx-3 pb-5 pt-5">
        <div class="d-flex flex-column align-center">
          <span
              class="mlx-5 mrx-5 f11 font-weight-bold align-self-start">{{ oracle.translate('ثبت نظر و امتیاز') }}</span>
          <span class="mlx-5 mrx-5 f8 mb-3 mt-1 align-self-start">
            {{ oracle.translate('نظر، انتقاد و یا پیشنهاد خود را راجع به سرویس دهی و کیفیت سفارش خود با ما به اشتراک بگذارید.') }}
          </span>
          <v-rating dir="ltr" size="64" v-model="rating" color="#7dc353" background-color="#7dc353"></v-rating>
          <v-textarea
              solo
              class="mb-5"
              :hint="oracle.translate('نظر، انتقاد و یا پیشنهاد خود را راجع به سرویس دهی و کیفیت سفارش خود با ما به اشتراک بگذارید.')"
              persistent-hint
              :placeholder="oracle.translate('متن نظر، انتقاد و یا پیشنهاد')"
              v-model="ratingNote"
          ></v-textarea>
          <div class="d-flex flex-row mt-5 mlx-5 mrx-5 mb-5 align-self-end btn-modal-creat">
            <v-btn class="text--white mrx-2 mlx-2"
                   width="120px" @click="ratingModal = false">
              <span style="color: black" class="f9">{{ oracle.translate('انصراف') }}</span>
            </v-btn>
            <v-btn color="#7dc353" class="text--white"
                   type="primary" width="200px" @click="setReview">
              <span style="color: white"
                    class="f9 font-weight-bold">{{ oracle.translate('ثبت و ارسال بازخورد') }}</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import oracle from "@/oracle";
import Favorites from "@/pages/favorites";
import Contactus from "@/pages/contactus";
import Addresses from "@/pages/addresses.vue";

export default {
  name: "profile",
  components: {Contactus, Favorites, Addresses},
  data: () => ({
    oracle: oracle,
    page: 1,
    mode: false,
    modetype: "showTiket",
    dialogCreat: false,
    modalEdite: false,
    showinfocar: false,
    colorcar: "",
    Check_index: "",
    radios: "",
    datalist: [
      {
        title: "سفارشات",
        icon: "article",
        key: "orders",
      },
      {
        title: "اطلاعات کاربری",
        icon: "account_circle",
        key: "userinfo",
      },
      {
        title: "محصولات مورد علاقه",
        icon: "favorite",
        key: "favorite",
      },
      {
        title: "آدرس های من",
        icon: "place",
        key: "addresses",
      },
      {
        title: "تراکنش های مالی",
        icon: "credit_card",
        key: "payments",
      },
      {
        title: "صندوق پیام",
        icon: "mail",
        key: "messages",
      },
      {
        title: "پشتیبانی",
        icon: "support_agent",
        key: "support",
      },
      {
        title: "خروج",
        icon: "logout",
        key: "exit",
      },
    ],
    colocars: [
      {
        title: "ابی",
        color: "#0216ff",
      },
      {
        title: "زرد",
        color: "#fff909",
      },
      {
        title: "سفید",
        color: "#fff",
      },
      {
        title: "مشکی",
        color: "#000",
      },
      {
        title: "خاکستری",
        color: "#9c9c9c",
      },
      {
        title: "سبز",
        color: "#19ff07",
      },
    ],
    ratingModal: false,
    rating: 5,
    currentOrderReview: null,
    ratingNote: null,
    orderList: [],
    paymentList: [],
    messageList: [],
    user_vehicles: [],
    phone: "",
    email: "",
    username: "",
    birth_date: "",
    profile: "",
    user_wallet: null,
    pricewall: "",
    optionMessage: "",
    sendStatus: 0,
    changeBack: false,
    changeBack2: false,
    modalEdite_sub: false,
    itemOrder: "",
    model: "",
    pelakFirst: "",
    pelakSecond: "",
    isEN: oracle.isEN()
  }),
  methods: {
    setReview() {
      this.oracle.axios("review/create", {
        order_id: this.currentOrderReview.order_id,
        comment_rate: this.rating,
        comment_text: this.ratingNote,
      }, () => {
        this.rating = 5
        this.ratingNote = ""
        this.ratingModal = false
        this.handelselectmenu("orders")
        oracle.showSuccess(oracle.translate('بازخورد شما با موفقیت ثبت شد!'))
      })
    },
    orderFunction(item) {
      if (item.order_state == 6) {
        oracle.scrollToTop()
        this.currentOrderReview = item
        this.ratingModal = true
      }
    },
    handelselectmenu(key) {
      if (key == "exit") {
        oracle.showMessage(
            oracle.translate('در این صورت از حساب کاربری خود خارج خواهید شد. ادامه میدهید؟'),
            oracle.translate('بله، خارج میشوم'),
            () => {
              oracle.logOut();
              this.$router.push("/");
            })
      } else if (key == "orders") {
        this.mode = key;
        oracle.axios(
            "order/getList",
            {limit_by: 500, offset_by: 0},
            this.GetOrderList
        );
      } else if (key == "payments") {
        this.mode = key;
        oracle.axios(
            "payment/getTransactions",
            {limit_by: 500, offset_by: 0},
            this.GetPaymentList
        );
      } else if (key == "messages") {
        this.mode = key;
        oracle.axios(
            "message/getAll",
            {limit_by: 500, offset_by: 0},
            this.GetMessageList
        );
      } else if (key == "userinfo") {
        this.mode = key;
        oracle.axios("user/getProfile", {}, this.GetProfile);
      } else {
        this.mode = key;
      }
    },
    CreateWall() {
      oracle.axios("payment/create", {
        payment_type: 0,
        payment_amount: this.pricewall,
        payment_tag: "https://cluna.app/profile",
      }, (response) => {
        window.location = response.data.payment_url;
      });
    }, GetProfile(response) {
      this.profile = response.data;
      this.phone = this.profile.phone;
      this.email = this.profile.user_profile.email;
      this.username = this.profile.username;
      this.birth_date = this.profile.user_profile.birth_date;
    },
    EditeProfile() {
      if (this.username == null || this.username.trim().length == 0) {
        oracle.showMessage(oracle.translate('نام و نام خانوادگی خود را وارد نمایید.'))
        return
      }
      oracle.axios(
          "user/edit",
          {
            user_profile: {birth_date: this.birth_date, email: this.email},
            username: this.username,
          },
          (res) => {
            oracle.showSuccess(oracle.translate('حساب کاربری با موفقیت به روزرسانی شد!'))
          }
      );
    },
    openCredit() {
      oracle.scrollToTop()
      this.dialogCreat = true
    },
    GetMessageList(response) {
      this.messageList = response.data;
      oracle.axios("message/readAll", null);
    },
    GetPaymentList(response) {
      this.paymentList = response.data;
    },
    GetOrderList(response) {
      for (let i = 0; i < response.data.length; i++) {
        let stateText = '';
        if (response.data[i].order_refund == 1) {
          stateText = "ریفاند به کیف پول"
        } else if (response.data[i].order_refund == 2) {
          stateText = "ریفاند به حساب بانکی"
        } else {
          switch (response.data[i].order_state) {
            case 0:
              stateText = "ثبت شد"
              break
            case 1:
              stateText = "لغو شد"
              break
            case 2:
              stateText = "جستجوی پیک"
              break
            case 3:
              stateText = "جستجوی پیک"
              break
            case 4:
              stateText = "پیک یافت شد"
              break
            case 5:
              stateText = "پیک در فروشگاه"
              break
            default:
              if (response.data[i].review == null) {
                stateText = "ثبت نظر و امتیاز"
              } else {
                stateText = "تحویل داده شد"
              }
              break
          }
        }
        response.data[i].stateText = oracle.translate(stateText)
      }
      this.orderList = response.data;
    },
  },
  mounted() {
    oracle.axios("user/getProfile", {}, this.GetProfile);
    this.handelselectmenu("orders")
  },
};
</script>
<style>
.profile {
  background: #fff;
}

.profile .profile-page {
  min-height: calc(100vh - 110px);
}

.profile .sidedbar {
  min-height: calc(100vh - 110px);
  background-color: #333;
  padding-top: 15px;
  color: #fff;
}

.profile .avatar {
  width: 90px;
  height: 90px;
  display: flex;
  position: relative;
  margin: 0 auto 1.5em;
  min-width: 90px;
  min-height: 90px;
  background: #7fc452;
  border-radius: 100%;
}

.profile .img-profile {
  width: 90px;
  height: 90px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.profile th {
  width: unset !important;
}

.profile .img-profile img {
  width: 100%;
  height: 100%;
}

#uploaduser {
  width: 0;
  height: 0;
  opacity: 0;
}

.profile .uploadAvatar {
  position: absolute;
  right: 0;
  bottom: -3px;
}

.profile .uploadAvatar .v-icon {
  font-size: 25px !important;
  color: #7dc353 !important;
}

.profile .credit {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.profile .credit span {
  margin: 0 5px;
  font-size: 13px;
}

.profile .btn-profile {
  margin: 15px 0;
  display: flex;
  justify-content: center;
}

.profile .menu-profile ul {
  display: flex;
  flex-direction: column;
}

.profile .menu-profile ul li {
  line-height: 40px;
  cursor: pointer;
  padding: 0 30px;
  font-size: 14px;
  color: #fff !important;
}

.profile .menu-profile ul li .v-icon {
  font-size: 15px;
  color: #fff !important;
}

.profile .main-profile {
  min-height: calc(100vh - 110px);
  padding: 15px;
  font-size: 12px;
}

.profile .showprofile {
  position: relative;
  min-height: calc(100vh - 110px);
  padding: 15px;
  font-size: 12px;
  overflow: hidden;
}

.profile .table_css {
  width: 100%;
}

.profile .table_css thead {
  background: #7dc353;
  color: #fff;
  font-size: 13px;
}

.profile .table_css thead p {
  margin: 0;
  font-weight: bold !important;
}

.profile .btn-send-message button {
  background: #7dc353;
  color: #fff !important;
}

.profile .title-table,
.profile .title-table-payments,
.profile .title-table-messages {
  display: flex;
  justify-content: space-between;
  text-align: center !important;
}

.profile .title-table span,
.profile .title-table-payments span,
.profile .title-table-messages span {
  font-size: 13px;
  padding: 10px 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.profile .content-profile,
.profile .content-payments,
.profile .content-messages {
  background: rgba(0, 0, 0, 0.075);
  padding: 5px;
  display: flex;
  justify-content: center;
}

.profile .content-profile span,
.profile .content-payments span,
.profile .content-messages span {
  font-size: 13px;
}

.profile .footer-profile {
  margin: 20px 0;
}

.profile .content-support {
  display: flex;
  flex-direction: column;
}

.profile .fieldProfilesupport {
  margin: 0 15px !important;
  color: #333;
  font-size: 12px;
  padding: 5px 0;
}

.profile .fieldProfilesupport span {
  font-size: 15px;
  padding: 2px;
}

.profile .fieldProfilesupport .v-textarea textarea {
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
}

.profile .fieldProfilesupport .v-text-field input,
.profile .fieldProfilesupport .vpd-input-group input,
.profile .fieldProfilesupport .v-textarea textarea,
.profile .field-modal-creat .v-text-field input,
.profile .field-user-info .v-text-field input,
.profile .name-car .v-text-field input {
  font-size: 15px;
}

.profile .fieldProfilesupport
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot,
.profile .name-car
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot {
  box-shadow: none !important;
}

.profile .fieldProfilesupport .v-text-field.v-text-field--solo .v-input__control,
.profile .field-modal-creat .v-text-field.v-text-field--solo .v-input__control,
.profile .field-user-info .v-text-field.v-text-field--solo .v-input__control {
  min-height: 40px !important;
  margin: 10px 0;
}

.profile .name-car .v-text-field.v-text-field--solo .v-input__control {
  min-height: 30px;
}

.profile .name-car .btn-send-pro button {
  font-size: 12px !important;
  color: #fff !important;
  margin: 0 15px;
}

.profile .title-modal-creat {
  display: flex;
  justify-content: space-between;
  background: #7dc353;
  color: #fff;
  padding: 10px;
}

.profile .title-modal-creat h3 {
  font-size: 13px;
}

.profile .title-modal-creat .v-icon {
  font-size: 18px !important;
  color: #fff !important;
}

.profile .content-modal-creat {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile .content-modal-creat span {
  font-size: 13px;
  padding: 15px 0;
}

.profile .field-modal-creat label,
.profile .field-user-info label,
.profile .name-car label {
  color: #333 !important;
  font-size: 12px;
}

.profile .field-modal-creat,
.profile .field-user-info,
.profile .name-car {
  font-size: 12px;
  padding: 5px 0;
  width: 50%;
}

.profile .field-user-info {
  width: 100%;
}

.profile .field-modal-creat
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot,
.profile .field-user-info
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #ced4da;
}

.profile .btn-modal-creat {
  color: #fff !important;
  margin: 15px 0;
  font-size: 12px !important;
}

.profile .content-user-info {
  display: flex;
}

.profile .btn-user-info button,
.profile .btn-car button {
  color: #fff !important;
}

.profile .btn-car button .v-icon {
  padding: 0 10px;
}

.profile .btn-car button {
  width: 23%;
  display: flex;
  margin: 0 auto;
  height: 43px !important;
}

.profile .modal-car {
  position: absolute;
  top: 100%;
  height: 100%;
  left: 0;
  transition: 0.3s;
  width: 100%;
  opacity: 0;
  visibility: hidden;
}

.profile .actives {
  top: 0;
  opacity: 1;
  visibility: visible;
}

.profile .title-modal-car {
  padding: 15px;
  background-color: #cecece;
  display: flex;
  justify-content: space-between;
}

.profile .r-title-modal-car {
  color: #6c757d !important;
}

.profile .r-title-modal-car span {
  font-size: 12px;
  padding: 0 10px;
}

.profile .r-title-modal-car .v-icon,
.profile .title-modal-car .v-icon {
  font-size: 20px;
}

.profile .item-modal-car {
  display: flex;
  justify-content: space-between;
  padding: 9px 7px;
  background-color: #f2f2f2;
  margin-top: 13px;
  border-radius: 5px;
  font-size: 12px;
}

.profile .edite-box .v-icon {
  font-size: 20px;
}

.profile .content-modal-car {
  display: flex;
}

.profile .box-modal-car {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.profile .footer-modal-car button {
  color: #fff !important;
  width: 100%;
  display: flex;
  height: 45px !important;
  font-size: 12px !important;
}

.profile .footer-modal-car {
  display: flex;
  justify-content: flex-end;
  bottom: 0;
}

.profile .btn-edite-car .v-icon {
  font-size: 17px !important;
}

.profile .items-car {
  font-size: 12px;
  line-height: 0;
}

.profile .item-card-edite {
  min-height: 30px;
  width: 90px;
  padding: 0;
}

.profile .items-car {
  display: flex;
  justify-content: center;
}

.profile .v-menu__content {
  top: 120px !important;
  left: 1062px !important;
}

.profile .title-modalEdite .v-icon {
  color: #7dc353;
  font-size: 20px !important;
}

.profile .title-modalEdite {
  display: flex;
  justify-content: space-between !important;
  padding: 1rem 15px;
}

.profile .name-car {
  display: flex;
  width: 100%;
}

.profile .name-car,
.profile .name-car v-text-field {
  padding: 5px 25px;
  background: #e0e0e0;
}

.profile .name-car
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot {
  background: #e0e0e0;
}

.profile .name-car {
  height: 40px !important;
  border-radius: 5px;
}

.profile .number-car {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.profile .r-number-car {
  display: flex;
}

#table p {
  font-size: 12px;
  margin: 10px 0;
}

.profile .r-number-car span {
  background-color: #7dc353;
  padding: 7px;
  border-radius: 0 3px 3px 0;
  color: #fff;
  font-size: 12px;
}

.profile .r-number-car
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot {
  box-shadow: none;
  background-color: #e0e0e0;
  border: 1px solid #ced4da;
}

.profile .r-number-car .v-text-field.v-text-field--solo .v-input__control,
.profile .numberscar .v-text-field.v-text-field--solo .v-input__control,
.profile .colorcar .v-text-field.v-text-field--solo .v-input__control {
  min-height: 35px;
}

.profile .r-number-car .v-text-field.v-text-field--solo .v-input__control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.profile .numberscar .v-input__slot,
.profile .colorcar .v-input__slot {
  background: #e0e0e0 !important;
}

.profile .box-modalEdite {
  min-height: 300px;
}

.profile .box-modalEdite h5 {
  margin: 5px 15px;
}

.profile .box-modalEdite p {
  margin: 0 15px;
  font-size: 12px;
}

.profile .item-color-car {
  background-color: #0216ff;
  width: 45px;
  height: 45px;
  border: 1px solid #000;
  border-radius: 50%;
  padding: 16px;
  cursor: pointer;
  margin: 0 5px;
}

.profile .color-car {
  display: flex;
  justify-content: center;
}

.profile .footer-modalEdite button {
  width: 100%;
  border-radius: unset !important;
  color: #fff !important;
  /*margin-top: 10px;*/
  padding: 20px 0 !important;
}

#table tr th {
  border-bottom: 1px solid #7dc353;
}

#table tr:nth-child(odd) {
  background: #eef7e9;
  color: #001e60;
}

.profile .ticket {
  background-color: #eee;
  overflow: auto;
  padding: 15px 0;
}

.profile .mainTicket {
  height: 80%;
  overflow: auto;
  margin: 0 20px;
}

.profile .itemticket {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center !important;
}

.profile .itemticket .v-icon {
  font-size: 4.5em;
}

.profile .btn-ticket button {
  background-color: #7dc353 !important;
  color: #fff !important;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 75.5%;
  text-align: center !important;
  padding: 0 !important;
  border: none;
}

.profile .btn-ticket {
  width: 100%;
}

.profile .title-boxTicket {
  display: flex;
  justify-content: space-between;
  color: #707070;
  border-bottom: 1px solid #707070;
  padding: 0 10px;
  padding-top: 5px;
}

.profile .text-boxTicket ul {
  display: flex;
  align-items: center;
  color: #707070;
}

.profile .text-boxTicket span {
  font-size: 14px;
}

.profile .text-boxTicket ul li:first-child {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  overflow: hidden;
  margin-left: 5px;
  margin-right: 5px;
}

.profile .boxTicket {
  border-radius: 10px 10px 0 0 !important;
  padding: 0;
  background: #fff;
  margin-top: 15px;
}

.profile .footer-boxTicket {
  background-color: #7dc353;
  color: #fff;
  font-size: 12px;
  padding: 0 8px;
  padding-bottom: 5px;
  padding-top: 10px;
}

.profile .content_boxTicket {
  height: 70px;
  padding: 5px 10px;
}

.profile .addTicket {
  color: #fff !important;
  text-decoration: none;
}

.profile .footer-boxTicket p {
  margin: 0;
}

.profile .dateticket span {
  padding: 0 3px;
}

.profile .dateticket {
  font-size: 13px;
}

.profile .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: #000 !important;
}

.profile .content_boxTicket p {
  font-weight: bold;
}

.profile .upload_image {
  display: flex;
  justify-content: flex-start;
}

.profile .image_request {
  width: 70px;
  height: 70px;
}

.profile .image_request img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

#uploadFile {
  width: 0;
  height: 0;
  opacity: 0;
}

.profile .chat {
  display: flex;
  flex-direction: column;
  height: 96%;
}

.profile .mainChat {
  height: 100%;
  background-image: url("../assets/image/catstile_transparent.png");
  background-size: cover;
  padding: 15px 25px;
  flex-direction: column;
  justify-content: flex-end;
  overflow: auto;
}

.profile .addChat {
  display: flex;
  align-items: flex-start;
  background: #fff;
  max-height: 200px;
  overflow: hidden;
}

.profile .inputsChat {
  padding: 0;
  margin: 0 15px;
}

.profile .inputsChat .v-input__control > .v-input__slot:before {
  border-color: transparent !important;
}

.profile .inputsChat .v-input__control > .v-input__slot:after {
  border-color: transparent !important;
}

.profile .sendMessage,
.profile .senduserpic {
  box-shadow: none;
  position: sticky;
  top: 0;
}

.profile .sendMessage i,
.profile .senduserpic i {
  color: #7dc353 !important;
}

.profile .inputsChat .v-text-field__slot {
  max-height: 100%;
}

.profile .star {
  color: red;
}

.profile .imgsize {
  width: 40%;
  height: auto;
  overflow: hidden;
}

.profile .textMessage {
  width: 80%;
  padding: 10px 8px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  margin-bottom: 1em;
  min-height: 75px;
  align-self: flex-start;
  text-align: right;
}

.profile .sendTextMessage {
  background: #fff;
}

.profile .sendTextMessage::after {
  content: "";
  position: absolute;
  right: -20px;
  top: 0;
  width: 0;
  height: 0;
  border-top: 0px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 30px solid #ffffff;
}

.profile .receiveTextMessage {
  background: #f5faf1;
  align-self: flex-end;
  float: left;
}

.profile .receiveTextMessage::after {
  content: "";
  position: absolute;
  left: -20px;
  top: 0;
  width: 0;
  height: 0;
  border-top: 0px solid transparent;
  border-bottom: 20px solid transparent;
  border-right: 30px solid #f5faf1;
}

.profile .timeDate span {
  font-size: 13px;
  color: #949494;
}

.profile .textMessages span {
  font-size: 14px;
}

/*@media only screen and (max-width: 320px) {*/
/*    .profile .itemticket .v-icon {*/
/*        font-size: 2em;*/
/*    }*/

/*    .profile .text-boxTicket ul li span,*/
/*    .profile .title-boxTicket p {*/
/*        font-size: 10px;*/
/*        text-align: center !important;*/
/*        display: flex;*/
/*    }*/

/*    .profile .v-application p {*/
/*        margin-bottom: 9px;*/
/*    }*/

/*    .profile .footer-boxTicket {*/
/*        font-size: 12px;*/
/*        height: 25px;*/
/*        display: flex;*/
/*        align-items: center;*/
/*    }*/
/*}*/

.profile .creation {
  height: 90%;
  overflow: scroll;
  padding: 30px 20px;
}

.profile .titlecreation label {
  font-size: 14px;
  color: #707070;
  text-align: right;
}

.profile .titlecreation .v-text-field {
  padding: 10px 0;
}

.profile .title-contenCreation {
  display: flex;
  color: #707070;
  padding: 10px 5px;
}

.profile .title-contenCreation span {
  padding-right: 10px;
  padding-left: 10px;
  font-size: 14px;
}

.profile .uploadRequest p {
  color: #707070;
  font-size: 14px;
}

.profile .uploadRequest {
  display: flex;
  flex-direction: column;
}

.profile .image_request {
  width: 140px;
  height: 140px;
}

.profile .image_request img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.profile .upload_image {
  display: flex;
  justify-content: flex-end;
}

.profile .title-contenCreation .v-icon {
  font-size: 30px;
}

.profile .w-setup {
  width: 150px !important;
  max-width: 150px !important;
  min-width: 150px !important;
  margin-left: auto;
  margin-right: auto;
}

#uploadFile {
  width: 0;
  height: 0;
  opacity: 0;
}

/*@media only screen and (max-width: 480px) {*/
/*    .profile .titlecreation label,*/
/*    .profile .uploadRequest p {*/
/*        font-size: 12px;*/
/*    }*/

/*    .profile .title-contenCreation .v-icon {*/
/*        font-size: 17px;*/
/*    }*/

/*    .profile .title-contenCreation span {*/
/*        font-size: 12px;*/
/*    }*/

/*    .profile .image_request {*/
/*        width: 100px;*/
/*        height: 100px;*/
/*    }*/

/*    .profile .image_request img {*/
/*        width: 100%;*/
/*        height: 100%;*/
/*        object-fit: contain;*/
/*    }*/

/*    .profile .uploadRequest {*/
/*        margin-bottom: 3em;*/
/*    }*/

/*    .profile .v-btn {*/
/*        height: 40px !important;*/
/*    }*/

/*    .profile .v-btn span {*/
/*        font-size: 12px;*/
/*    }*/

/*    .profile .main-profile {*/
/*        width: 100%;*/
/*        overflow: auto;*/
/*    }*/

/*    .profile .btn-ticket button {*/
/*        width: 100%;*/
/*    }*/
/*}*/
</style>
